/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui.inverted.basic.segment[_ngcontent-%COMP%]{min-height:calc(100vh - 375px);overflow-x:auto;background:0 0;max-width:1200px;margin:20px auto}td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:rgba(255,255,255,.9)}"];
export { styles as styles };
